import { address } from './address';
import { cart } from './cart';
import { common } from './common';
import { cookiePage } from './cookiePage';
import { habaAddress } from './habaAddress';
import { habaAddressBook } from './habaAddressBook';
import { habaCart } from './habaCart';
import { habaCatalogForm } from './habaCatalogForm';
import { habaCheckout } from './habaCheckout';
import { habaCommon } from './habaCommon';
import { habaContactForm } from './habaContactForm';
import { habaCountries } from './habaCountries';
import { habaCountryPopup } from './habaCountryPopup';
import { habaMyAccountNavigation } from './habaMyAccountNavigation';
import { habaMyAccountOrderHistory } from './habaMyAccountOrderHistory';
import { habaProduct } from './habaProduct';
import { habaUser } from './habaUser';
import { habaWishlist } from './habaWishlist';
import { overwriteDefaults } from './overwriteDefaults';
import { product } from './product';
import { returns } from './returns';
import { seo } from './seo';
import { userProfile } from './userProfile';
import {habaAltText} from "./alt-text";
import {habaProductAdvisor} from "../de/habaProductAdvisor";

export const enTranslations = {
  address,
  cart,
  common,
  cookiePage,
  habaAddress,
  habaAddressBook,
  habaCart,
  habaCatalogForm,
  habaContactForm,
  habaCheckout,
  habaCommon,
  habaCountries,
  habaCountryPopup,
  habaMyAccountNavigation,
  habaMyAccountOrderHistory,
  habaProduct,
  habaProductAdvisor,
  habaUser,
  habaWishlist,
  userProfile,
  overwriteDefaults,
  product,
  returns,
  seo,
  habaAltText
};
